import React from 'react';
import style from './style.module.scss';
import { DropDownStatus } from '../dropdown-status';
import { StoreTag } from '../store-tag';
import { storeCarWashStatusOptions } from '../../helpers/store-helper';

type StoreEditingCarWashStatusProps = {
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
};

export const StoreEditingCarWashStatus = ({
    selectedStatus,
    setSelectedStatus,
}: StoreEditingCarWashStatusProps) => {
    const statusOptions = Object.entries(storeCarWashStatusOptions).map(
        ([key, value]) => ({
            label: value,
            value: key,
        })
    );
    return (
        <>
            <div>
                <div className={style.dropdown_wrapper}>
                    <DropDownStatus
                        options={statusOptions ?? []}
                        onChange={setSelectedStatus}
                        placeholder="Select status here"
                        selectedOption={selectedStatus}
                    />
                    <div className={style.tag_wrapper}>
                        <StoreTag status={selectedStatus} />
                    </div>
                </div>
            </div>
        </>
    );
};
